import { Stack } from "@mui/material";

import { ModelCardFragment } from "../../models.graphql";
import { InfoIndicator } from "./ModelInfoIndicator";
import { LinkIndicator } from "./ModelLinkIndicator";

export { INDICATOR_CLASS, IndicatorContainer } from "./shared";

interface ModelCardIndicatorsProps {
  model: ModelCardFragment;
  onClickLabel?: (event: React.MouseEvent, labelId: string) => void;
  isUserWorkspaceModel: boolean;
}

export const ModelCardIndicators = (props: ModelCardIndicatorsProps) => {
  const { model, onClickLabel, isUserWorkspaceModel } = props;

  const shouldShowLinkIndicator =
    model.isLinkedToWorkspace && !isUserWorkspaceModel;

  return (
    <Stack
      direction="row"
      sx={{
        position: "absolute",
        bottom: 0,
        right: 0,
        zIndex: 2,
        gap: 1,
      }}
    >
      {shouldShowLinkIndicator && <LinkIndicator />}
      <InfoIndicator
        model={model}
        isUserWorkspaceModel={isUserWorkspaceModel}
        onClickLabel={onClickLabel}
      />
    </Stack>
  );
};
